import React from 'react';

class ProofreadSVG extends React.Component {
  render () {
    let classes = this.props.className ? ["svg-inline--fa", this.props.className].join(' ') : "svg-inline--fa";
    let style = this.props.style ? this.props.style : undefined;

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="message" className={classes} role="img" 
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0  703 703" style={style} onClick={this.props.onClick?this.props.onClick:undefined}>
        <path fill="currentColor" d="M675.4,213.1c-17.7-41.9-43-79.4-75.3-111.7C567.8,69.1,530.2,43.7,488.3,26C445,7.7,398.9-1.6,351.5-1.6S258,7.7,214.7,26
          c-41.9,17.7-79.4,43-111.7,75.3c-32.3,32.3-57.6,69.9-75.3,111.7C9.3,256.4,0,302.4,0,349.9s9.3,93.5,27.6,136.8
          c17.7,41.9,43,79.4,75.3,111.7c32.3,32.3,69.9,57.6,111.7,75.3c43.3,18.3,89.4,27.6,136.8,27.6s93.5-9.3,136.8-27.6
          c41.9-17.7,79.4-43,111.7-75.3s57.6-69.9,75.3-111.7c18.3-43.3,27.6-89.4,27.6-136.8S693.7,256.4,675.4,213.1z M245,384.7
          l37.2-159.4c22.5-4.9,48.3,3.6,67.4,22.7c20.8,20.8,29.1,49.8,21.3,73.7c-2.7,8-0.6,16.7,5.4,22.7c6,6,14.6,8,22.7,5.4
          c23.8-7.9,52.8,0.3,73.5,21.3c19.1,19.1,27.6,44.9,22.7,67.6L336,475.7C315.5,437.2,283.5,405,245,384.7z M291.1,486.3l-73.9,17.3
          l17.3-73.9C257.4,443.9,276.9,463.5,291.1,486.3z M445.7,306.1l149.7-150c29,36.4,49.3,78.4,59.6,123.4L537.2,397.6
          c-5.5-21.1-16.7-41.4-33.4-58.1C487.2,322.8,467,311.7,445.7,306.1z M565.4,123.4l-151,151.2c-5.5-21.1-16.7-41.6-33.4-58.1
          c-16.5-16.7-36.8-28-58-33.4L451.3,54.7C493.5,68.9,532.3,92.1,565.4,123.4z M571.8,570.1c-58.8,58.8-137.1,91.2-220.3,91.2
          S190.1,629,131.2,570.1C72.4,511.3,40,433.1,40,349.9s32.4-161.4,91.2-220.3c58.8-58.8,137.1-91.2,220.3-91.2
          c16.7,0,33.2,1.3,49.4,3.9L246.7,196.7c-3,3-5,6.6-6,10.7l-74.8,320.8c-1.7,7.6,0.5,15.3,6,20.8c6.1,6.1,14.6,7.2,20.8,6L513,479.8
          c4.1-0.9,7.7-3,10.7-6l138.9-139.2c0.2,5,0.4,10.1,0.4,15.2C663,433.1,630.6,511.3,571.8,570.1z"/>
      </svg>
    );
  }
}

export default ProofreadSVG;